import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from "react";
import { LayoutRow } from "./LayoutRow";
/**
 * Layout cell in react-page layout
 * @param props
 * @returns
 */
export function LayoutRows(props) {
    const { rows } = props, rowProps = __rest(props, ["rows"]);
    const children = rows ? (rows.map((row) => _jsx(LayoutRow, Object.assign({ node: row }, rowProps), row.id))) : (_jsx(Fragment, {}));
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=LayoutRows.js.map